let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [{
        label: '下载日期',
        props: 'warnNo',
        minWidth: 220,
    },
    {
        label: '下载类型',
        props: 'pileCode',
        minWidth: 220,
    },
    {
        label: '消息状态',
        props: 'statusName',
        minWidth: 200,
    },
    {
        label: '一级类型',
        props: 'warnTypeName',
        minWidth: 200,
    },
    {
        label: '二级类型',
        props: 'warnDetailTypeName',
        minWidth: 200,
    },
    {
        label: '内容',
        props: 'content',
        minWidth: 200,
    },
    {
        label: '创建时间',
        props: 'createdWhen',
        minWidth: 200,
    },
    // {
    //     label: '备注',
    //     props: 'remark',
    //     minWidth: 200,
    // }
];

// // 面包屑
pageConfig.listBreadCrumb = [{
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '系统管理'
    },
    {
        type: 'title',
        name: '消息管理'
    }
];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: false,
    showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}

pageConfig.formRules = {};



export default pageConfig;